import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-subscription-terms-conditions-modal',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent
  ],
  templateUrl: './subscription-terms-conditions-modal.component.html',
  styleUrls: ['./subscription-terms-conditions-modal.component.scss']
})
export class SubscriptionTermsConditionsModalComponent {
  @Input() isVisible = false;
  @Output() accepted = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.close();
    }
  }

  close(): void {
    this.closed.emit();
  }

  accept(): void {
    this.accepted.emit();
    this.close();
  }
}
